// src/services/vgcaSignService.js
import { userManager } from "@app/utils/oidc";
import { BaseGateway } from "@app/utils/apiUrl";

function callVgcaSign(signFunctionName, params) {
  return new Promise((resolve, reject) => {
    const fn = window[signFunctionName];

    if (!fn) {
      reject(new Error(`Không tìm thấy hàm ${signFunctionName}. Kiểm tra vgcaplugin.js đã load chưa.`));
      return;
    }

    try {
      fn(JSON.stringify(params), function (rv) {
        try {
          const result = typeof rv === "string" ? JSON.parse(rv) : rv;

          if (result.Status === 0 || result.Status === true) {
            resolve(result);
          } else {
            reject(result);
          }
        } catch (err) {
          reject(err);
        }
      });
    } catch (err) {
      reject(err);
    }
  });
}

export async function signApprovedFile(fileUrl) {
  const user = await userManager.getUser();

  if (!user || !user.access_token) {
    throw new Error("Người dùng chưa đăng nhập SSO hoặc access_token không tồn tại.");
  }

  const params = {
    FileUploadHandler: `${BaseGateway}/DigitalSign/upload-signed-file`,
    SessionId: "",
    JWTToken: user.access_token,
    FileName: fileUrl || "",
  };

  return callVgcaSign("vgca_sign_approved", params);
}

export async function signIssuedFile(fileUrl, docNumber, issuedDate) {
  const user = await userManager.getUser();

  if (!user || !user.access_token) {
    throw new Error("Người dùng chưa đăng nhập SSO hoặc access_token không tồn tại.");
  }

  const params = {
    FileUploadHandler: `${BaseGateway}/DigitalSign/upload-signed-file`,
    SessionId: "",
    JWTToken: user.access_token,
    FileName: fileUrl || "",
    DocNumber: docNumber || "",
    IssuedDate: issuedDate || "",
  };

  return callVgcaSign("vgca_sign_issued", params);
}

export async function signIncomingFile(fileUrl, metadata = []) {
  const user = await userManager.getUser();

  if (!user || !user.access_token) {
    throw new Error("Người dùng chưa đăng nhập SSO hoặc access_token không tồn tại.");
  }

  const params = {
    FileUploadHandler: `${BaseGateway}/DigitalSign/upload-signed-file`,
    SessionId: "",
    JWTToken: user.access_token,
    FileName: fileUrl || "",
    MetaData: metadata,
  };

  return callVgcaSign("vgca_sign_income", params);
}

export async function signListFiles(files) {
  const user = await userManager.getUser();

  if (!user || !user.access_token) {
    throw new Error("Người dùng chưa đăng nhập SSO hoặc access_token không tồn tại.");
  }

  const params = {
    FileUploadHandler: `${BaseGateway}/DigitalSign/upload-signed-file`,
    SessionId: "",
    JWTToken: user.access_token,
    Files: files,
  };

  return callVgcaSign("vgca_sign_lylich", params);
}